var tabbableNode = /input|select|textarea|button|object/;
function hidden(element) {
  return element.offsetWidth <= 0 && element.offsetHeight <= 0 || element.style.display === 'none';
}
function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) {
      break;
    }
    if (hidden(parentElement)) {
      return false;
    }
    parentElement = parentElement.parentNode;
  }
  return true;
}
function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !('disabled' in element && element.disabled) || (nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}
function tabbable(element) {
  var _element$getAttribute;
  var tabIndexString = (_element$getAttribute = element.getAttribute('tabindex')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : undefined;
  var tabIndex = Number(tabIndexString);
  var isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}
export function findTabbableDescendants(element) {
  var _element$querySelecto;
  return Array.from((_element$querySelecto = element === null || element === void 0 ? void 0 : element.querySelectorAll('*')) !== null && _element$querySelecto !== void 0 ? _element$querySelecto : []).filter(tabbable);
}